import { render, staticRenderFns } from "./settingPassword.vue?vue&type=template&id=e9980f36&scoped=true"
import script from "./settingPassword.vue?vue&type=script&lang=js"
export * from "./settingPassword.vue?vue&type=script&lang=js"
import style0 from "./settingPassword.vue?vue&type=style&index=0&id=e9980f36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9980f36",
  null
  
)

export default component.exports